<template>
  <div>
<!--    :projectList="projectList"-->
		<search-list
			:businessStatus="businessStatus"
			:intentionAreaList="intentionAreaList"
			:salaryRangeList="salaryRangeList"
			:budgetRangeList="budgetRangeList"
			:intentionAddressList="intentionAddressList"
			@search="search"
		></search-list>
		<table-list
      :columns="columns"
      :data="data"
      :current="current"
      :total="total"
      :loading="loading"
      :cacheKey="'businessCache'"
      :hasSave="true"
			:defaultColumns="defaultColumns"
      @change-page="changePage"
		></table-list>
		<update-personas
   	 :n="updatePersonasKey"
			:uid="uid"
			:projectFid="projectFid"
			@done="getSearchData"
    ></update-personas>
		<check-personas
			:n="checkPersonasKey"
			:uid="uid"

		></check-personas>
  </div>
</template>

<script>
import {getSelectedData ,getBusinessEnums,getRegionEnum ,getCustomerList} from 'api/business'
import SearchList from './components/SearchList'
import TableList from "components/FilterTableList/index";
import updatePersonas from './components/UpdatePersonas'
import CheckPersonas from './components/CheckPersonas'
import { getProjectHouseType,getProjects } from 'api/common'

export default {
	components:{
		SearchList,
		TableList,
		updatePersonas,
		CheckPersonas
	},
	data(){
		return{
			projectFid:'',
			loading:false,
			current:0,
			total:0,
			limit:10,
			formData:{},
			projectList:[],
			businessStatus:[],
			intentionAreaList:[],
			salaryRangeList:[],
			budgetRangeList:[],
			defaultColumns:[],
			intentionAddressList:[],
			updatePersonasKey:0,
			checkPersonasKey:0,
			data:[],
			uid:'',
			columns:[
        {
          title:'编号',
          type: 'index',
          width: 60,
          align: 'center'
        },
        {
          title: ' '
        },
        {
          title: '姓名',
          align: 'center',
          key: 'realName',
          width: 120,
        },
        {
          title: ' '
				},
				{
          title: '手机号',
          align: 'center',
          key: 'customerMobile',
          width: 120,
        },
        {
          title: ' '
				},
				{
          title: '性别',
          align: 'center',
          key: 'customerSexName',
          width: 120,
        },
        {
          title: ' '
				},
				// {
        //   title: '商机状态',
        //   align: 'center',
        //   key: 'orgName',
        //   width: 120,
        // },
        // {
        //   title: ' '
				// },
				// {
        //   title: '意向房型',
        //   align: 'center',
        //   key: 'houseTypeName',
        //   width: 120,
        // },
        // {
        //   title: ' '
				// },
				// {
        //   title: '合同状态',
        //   align: 'center',
        //   key: 'orgName',
        //   width: 120,
        // },
        // {
        //   title: ' '
				// },
				// {
        //   title: '房间号',
        //   align: 'center',
        //   key: 'orgName',
        //   width: 120,
        // },
        // {
        //   title: ' '
				// },
				{
          title: '国籍',
          align: 'center',
          key: 'nationCodeName',
          width: 120,
        },
        {
          title: ' '
				},
				{
          title: '籍贯',
          align: 'center',
          key: 'provinceCodeName',
          width: 120,
        },
        {
          title: ' '
				},
				{
          title: '年龄',
          align: 'center',
          key: 'age',
          width: 120,
        },
        {
          title: ' '
				},
				{
          title: '证件类型',
          align: 'center',
          key: 'idTypeName',
          width: 120,
        },
        {
          title: ' '
				},
				{
          title: '学历',
          align: 'center',
          key: 'customerEduName',
          width: 120,
        },
        {
          title: ' '
				},
				{
          title: '当前状态',
          align: 'center',
          key: 'currentStatusName',
          width: 120,
        },
        {
          title: ' '
				},
				{
          title: '工作地点',
          align: 'center',
          key: 'workAddressName',
          width: 200,
        },
        {
          title: ' '
				},
				{
          title: '机构名称',
          align: 'center',
          key: 'originalName',
          width: 120,
        },
        {
          title: ' '
				},
				{
          title: '薪资范围',
          align: 'center',
          key: 'salaryRangeName',
          width: 120,
        },
        {
          title: ' '
				},
				{
          title: '获知自如寓渠道',
          align: 'center',
          key: 'channelName',
          width: 120,
        },
        {
          title: ' '
				},
				{
          title: '自如寓印象',
          align: 'center',
          key: 'impressionName',
          width: 120,
        },
        {
          title: ' '
				},
				{
          title: '期望入住时间',
          align: 'center',
          key: 'intentionInTime',
          width: 120,
        },
        {
          title: ' '
				},
				{
          title: '预算范围',
          align: 'center',
          key: 'budgetRangeName',
          width: 120,
        },
        {
          title: ' '
				},
				{
          title: '几人居住',
          align: 'center',
          key: 'checkinNum',
          width: 120,
        },
        {
          title: ' '
				},
				{
          title: '意向户型',
          align: 'center',
          key: 'houseTypeName',
          width: 120,
        },
        {
          title: ' '
				},
				{
          title: '意向面积',
          align: 'center',
          key: 'intentionAreaName',
          width: 120,
        },
        {
          title: ' '
				},
				{
          title: '通勤方式',
          align: 'center',
          key: 'commutingModeName',
          width: 120,
        },
        {
          title: ' '
				},
				{
          title: '是否短租',
          align: 'center',
          key: 'rentTypeName',
          width: 120,
        },
        {
          title: ' '
				},
				{
          title: '租住时长',
          align: 'center',
          key: 'rentLength',
          width: 120,
        },
        {
          title: ' '
				},
				{
          title: '短租用途',
          align: 'center',
          key: 'shortRentDesName',
          width: 120,
        },
        {
          title: ' '
				},
				{
          title: '当前入住状态',
          align: 'center',
          key: 'currentCheckinStatusName',
          width: 120,
        },
        {
          title: ' '
				},
				{
          title: '租住需求状态',
          align: 'center',
          key: 'intentionLevelName',
          width: 120,
        },
        {
          title: ' '
				},
				{
          title: '当前居住房屋到期时间',
          align: 'center',
          key: 'rentEndTime',
          width: 120,
        },
        {
          title: ' '
				},
				{
          title: '当前居住地点',
          align: 'center',
          key: 'residenceName',
          width: 120,
        },
        {
          title: ' '
				},
				{
          title: '操作',
          align: 'center',
          width: 150,
          fixed: 'right',
          render:(h,params)=>{
            return [
              h('a', {
                directives:[
                  {
                    name:'p',
                    value:{
                      api:'customerInfo/getCustomerPortrait'
                    }
                  }
                ],
                on: {
                  click: () => {
                    this.$nextTick( ()=> {
											this.uid = params.row.uid;
                      this.checkPersonasKey++;
                    })
                  }
                },
                style: {
                  marginRight: '10px'
                }
              }, '查看'),
              h('a', {
                directives:[
                  {
                    name:'p',
                    value:{
                      api:'customerInfo/updateCustomer'
                    }
                  }
                ],
                on: {
                  click: () => {
										this.projectFid = params.row.projectFid;
										this.uid = params.row.uid;
                    this.updatePersonasKey++;
                  }
                }
              }, '修改')
            ]
          }
        },


			],

		}
	},
	created(){
		this.initData();
	},
	methods:{
		initData(){
			// getProjects().then( res => {
			// 	this.projectList = res.data;
			// });
			getSelectedData().then(res=>{
				this.businessStatus = res.data.status;
			});
			getBusinessEnums().then( res=> {
				this.salaryRangeList = res.data.salaryRange;
				this.intentionAreaList = res.data.intentionArea;
				this.budgetRangeList = res.data.budgetRange;
			});
		},
		search(data){
      this.searchParams = data
      this.page=1
      this.current=1
      this.getSearchData();
    },
		getSearchData(){
			let searchParams = {
				...this.searchParams,
				page:this.page,
				limit:this.limit
			}
			getCustomerList(searchParams)
			.then( res => {
				this.data = res.data.rows;
				this.total = res.data.total
				// this.data.forEach(ele=>{
				// 	if(ele.workAddress){
				// 		ele.workAddressName =ele.workAddressCityName +','+ele.workAddressAreaName+','+ele.workAddressName
				// 	}
				// 	if(ele.workAddressCityName&&!ele.workAddress){
				// 		ele.workAddressName =ele.workAddressCityName +','+ele.workAddressAreaName
				// 	}
				// 	if(ele.residence){
				// 		ele.residenceName =ele.residenceCityName +','+ele.residenceAreaName+','+ele.residenceName
				// 	}
				// 	if(ele.residenceCityName&&!ele.residence){
				// 		ele.residenceName =ele.residenceCityName +','+ele.residenceAreaName
				// 	}
				// })
			})
		},
		changePage(n){
      this.current = n;
      this.page = n;
      this.getSearchData()
    },
	}
}
</script>

<style>

</style>
